import { createApiActions } from '@tabeeb/shared/utils/actions'

export const get3dModels = createApiActions('GET_3D_MODELS')
export const create3dModel = createApiActions('CREATE_3D_MODEL')
export const delete3dModel = createApiActions('DELETE_3D_MODEL')
